import { QueryObserverOptions, useQuery } from 'react-query';

import axiosClient from '@lib/utils/axiosClient';

import { makeResourceKeys } from '../../makeResources/makeResourcesKeys';
import { Patient } from '../types';

const keys = makeResourceKeys('patients');

async function queryFn(patientId: string) {
  const { data } = await axiosClient.get(`/patients/${patientId}/duplicates`);
  return data;
}

export default function usePatientManyDups(patientId: string, options?: QueryObserverOptions<any>) {
  return useQuery<Patient[]>(keys.$entityId(patientId), () => queryFn(patientId), options);
}
